import { render, staticRenderFns } from "./ListItemCard.vue?vue&type=template&id=08a631c2&scoped=true&"
import script from "./ListItemCard.vue?vue&type=script&lang=js&"
export * from "./ListItemCard.vue?vue&type=script&lang=js&"
import style0 from "./ListItemCard.vue?vue&type=style&index=0&id=08a631c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a631c2",
  null
  
)

export default component.exports